import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { format } from 'date-fns'
import addDays from 'date-fns/addDays'
import isSameDay from 'date-fns/isSameDay'
import "react-datepicker/dist/react-datepicker.css";
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'

export default function DateRangeSelector(props) {


    const [startDate, setStartDate] = useState(props.startDate); //Date
    const [endDate, setEndDate] = useState(props.endDate); //Date
    const [monthsShown, setMonthsShown] = useState(window.innerWidth > 600 ? 2 : 18)
    const [calWidth, setCalWidth] = useState(window.innerWidth > 600 ? '579px' : '274px')
    const onChange = dates => {

        let [start, end] = dates;
        
        var correctedEnd;

        if (isSameDay(start, end)) {
            correctedEnd = addDays(start, 1);
        }
        else {
            correctedEnd = end;
        }
        setStartDate(start);
        
        setEndDate(correctedEnd);

        if (typeof end !== 'undefined' && end !== null) {
            props.apply(start, correctedEnd, differenceInCalendarDays(correctedEnd, start));
        }
    };
    function nights() {
        return differenceInCalendarDays(endDate, startDate);
    };
    function apply() {
        props.apply(startDate, endDate, nights());
    }
    function close() {
        props.close();
    }

    var dateArray = [];

    function convertDate(date) {
        var d = new Date(date);
        dateArray.push(d);
    }

    function convertToDateArray(stringArray, start, end) {  //if end date null only show up to start date

        stringArray.forEach(convertDate);

        if (start && end == null ) {
            dateArray = dateArray.filter(d => d < start);
        }
 
        return dateArray;

    }

    function excludeRange(stringArray, start, end) {

        return [];
        //if start date selected exclude
        if ((start && end) || (!start && !end)) {
            return [];
        }
        else {
            let closed = false;
            let count = 0;
            while (!closed) {
                let dateString = stringArray[count];
                let date = new Date(dateString)
                if (date > start) {
                    closed = true;
                    date.setDate(date.getDate() + 1);
                    var range = [{ start: date, end: addDays(date, 1000) }];
                    return range;
                }

                count++;
            }
        }

        return [];
        
    }

    function getMaxDate(stringArray, start, end) {

        

        let date = new Date();
        date.setDate(date.getDate() + (365 * 2));

        

        if ((start && end) || (!start && !end)) {
            
            return date;

        }
        else {

            if (stringArray.length === 0) return date;

            let closed = false;
            let count = 0;
            while (!closed) {
                let dateString = stringArray[count];
                let date = new Date(dateString)
                if (date > start) {
                    closed = true;
                    //date.setDate(date.getDate());
                    return date;
                }

                count++;
            }
        }

        return date;

    }

    return (
        <div style={{ width: calWidth, backgroundColor: 'white'}}>
            <div class="row" style={{margin: 'auto'}}>
                <button type="button"
                    class="close col-1 bg-white"
                    aria-label="Close"
                    onClick={() => close() }
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <button type="button" class="btn btn-light col" >
                    <span class='small'>Check-in</span><br/>
                    <span>{format(startDate, 'eee dd MMM yyyy')}</span>
                </button>
                {endDate === null &&
                <button type="button" class="btn btn-warning col">
                    
                        
                        <span >Select Check-out Date</span>
                        
                    </button>}

                {endDate !== null &&
                    <button type="button" class="btn btn-light col">
                        
                    <span class='small'>Check-out</span><br/>
                        <span>{format(endDate, 'eee dd MMM yyyy')}</span>

                </button>}
                
            </div>
            
            <DatePicker
                
                selected={startDate}
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                monthsShown={monthsShown}
                inline
                minDate={new Date()}
                showDisabledMonthNavigation
                //excludeDates={convertToDateArray(props.closedDates, startDate, endDate)}
                //maxDate={getMaxDate(props.closedDates, startDate, endDate)}
                //excludeDateIntervals={excludeRange(props.closedDates, startDate, endDate)}
                />
                
            {/*
            <div class="d-flex ">
                <span style={{width: '600px'}}class="mr-auto p-2">{(nights().toString() + ' night') + (nights() !== 1 ? 's' : '')}</span>
                <button
                    type="button"
                    class="btn btn-primary "
                    onClick={() => apply()}
                >APPLY</button>
            </div>*/}
        </div>
    );



}